export function isHandledDmArticleRefreshNotFound(
  url: string,
  method: string,
  status: number,
): boolean {
  if (status !== 404 || method.toUpperCase() !== 'POST') return false;

  const pathname = (() => {
    try {
      return new URL(url, 'https://taskmanager.local').pathname;
    } catch {
      return url.split(/[?#]/, 1)[0];
    }
  })();

  return /^\/api\/dm-artikel\/(?:dan|gtin)\/[^/]+\/refresh\/?$/.test(pathname);
}
